<template>
  <div class="section-color services" id="services">
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-12 about-me" data-aos="fade-in" data-aos-easing="linear">
          <h1 class="title has-text-centered section-title">{{ $t('message.services.head') }}</h1>
          <br />
          <h2 class="subtitle">
            {{ $t('message.services.description') }}
          </h2>
          <br />
        </div>
        <!-- <div class="column is-12"><div class="columns"> -->
          <div
            class="column is-4 has-text-centered"
            data-aos="fade-in"
            data-aos-easing="linear"
            v-for="(service, index) in $t('message.services.services')"
            :key="index"
          >
            <i :class="'fa-3x fa-' + service.icon"></i>
            <hr />
            <h2>
              {{ service.name }}
            </h2>
          </div>
        <!-- </div></div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Services'
}
</script>

<style>
.main-content .section-color.services .title,
.main-content .section-color.services .subtitle {
  color: white;
}
</style>
